import React from 'react';
import CoinsTable from '../../common/components/CoinsTable';
import Banner from './Banner/Banner';

const HomePage = () => {
  return (
    <>
      <Banner />
      <CoinsTable />
    </>
  );
};

export default HomePage;
